export default {
  name: 'Conference of Paris',
  shortName: 'Paris',
  description:
    'Launched in 2017, the Conference of Paris gathers decision makers across the worlds of business, government and civil society in order to promote the exchange of ideas and perspectives surrounding the major issues of our time.',
  thumbnail: '/images/events/paris/thumbnail-paris.jpg',
  link: 'https://www.conferencedeparis.com/',
  header: {
    content:
      'Launched in 2017, the Conference of Paris gathers decision makers across the worlds of business, government and civil society in order to promote the exchange of ideas and perspectives surrounding the major issues of our time.'
  },
  bullets: {
    bullet1: {
      number: '13th',
      label: 'Edition'
    },
    bullet2: {
      number: '1,400+',
      label: 'In-Person Participants'
    },
    bullet3: {
      number: '70+',
      label: 'Speakers'
    },
    bullet4: {
      number: '75+',
      label: 'Represented Countries'
    }
  },
  about: {
    title: 'Our Purpose',
    content:
      'The multi-day event encourages leaders to share their knowledge and understanding of global economic, social and environmental issues as a way to collaborate and collectively overcome these challenges. As the IEFA’s main annual European event, the Conference of Paris aims to nurture international trade between Europe and the Americas, while fostering wider global relationships which can lead to positive change.'
  },
  next: {
    title: 'Bridging The Divide',
    content:
      'This year’s edition will convene global leaders and decision makers to explore the ways in which coordinated, global action can reshape the current system to develop a new agenda for trade, growth and investment. Held at the OECD in Paris on November 28-29th, 2023, keynote talks and panel discussions will coincide with various networking opportunities such as luncheons and cocktail receptions, all designed to encourage connection and collaboration amongst participants.'
  },
  gallery: {
    title: 'Photo gallery',
    index: [
      {
        title: '12th edition',
        images: [
          '/images/events/paris/gallery/12th-paris-001.jpg',
          '/images/events/paris/gallery/12th-paris-002.jpg',
          '/images/events/paris/gallery/12th-paris-003.jpg',
          '/images/events/paris/gallery/12th-paris-004.jpg',
          '/images/events/paris/gallery/12th-paris-005.jpg',
          '/images/events/paris/gallery/12th-paris-006.jpg',
          '/images/events/paris/gallery/12th-paris-007.jpg',
          '/images/events/paris/gallery/12th-paris-008.jpg',
          '/images/events/paris/gallery/12th-paris-009.jpg'
        ]
      }
    ]
  },
  board: {
    uptitle: 'About',
    title: 'Board of Governors & Advisory Board',
    content:
      'The Conference of Paris leadership team works closely with a select group of individuals who form our Board of Governors and Advisory Board. All board members have been carefully selected for their in-depth knowledge and experience within their respective fields.'
  },
  governorsIndex: {
    title: 'Board of Governors',
    chairmens: {
      title: 'Co-Chairmen',
      index: [
        {
          name: 'Paul Desmarais Jr.',
          info: 'Chairman, Power Corporation of Canada (PCC)',
          image: '/images/boards/paris/paul_desmarais_jr.png'
        },
        {
          name: 'Jean-Pierre Clamadieu',
          info: 'Chairman, ENGIE',
          image: '/images/boards/paris/Clamadieu-Jean-Pierre.jpg'
        }
      ]
    },
    members: {
      title: 'Governors',
      index: [
        {
          name: 'Gil Rémillard ',
          info: 'Founding Chairman, International Economic Forum of the Americas (IEFA)',
          image: '/images/boards/paris/Gil_Remillard.jpg'
        },
        {
          name: 'Darius Adamczyk',
          info: 'Chairman and Chief Executive Officer, Honeywell',
          image: '/images/boards/paris/Darius-Adamczyk.jpg'
        },
        {
          name: 'Jean-Paul Agon',
          info: "Chairman, L'Oréal",
          image: '/images/boards/paris/Agon-Jean-Paul.jpg'
        },
        {
          name: 'Hélène Desmarais',
          info: 'Executive Chairman, IVADO and Chair of the Board HEC Montréal',
          image: '/images/boards/paris/desmarais-helene.jpg'
        },
        {
          name: 'Kristina M. Johnson',
          info: 'President, The Ohio State University',
          image: '/images/boards/paris/Johnson-Kristina.jpg'
        },
        {
          name: 'Jean Lemierre',
          info: 'Chairman, BNP Paribas',
          image: '/images/boards/paris/Jean-Lemierre.jpg'
        },
        {
          name: 'Shunichi Miyanaga',
          info: 'Chairman, Mitsubishi Heavy Industries',
          image: '/images/boards/paris/Miyanaga-Shunichi.jpg'
        },
        {
          name: 'Laurence Parisot',
          info: 'Chairman, Citigroup',
          image: '/images/boards/paris/Parisot-Laurence.jpg'
        },
        {
          name: 'Muriel Pénicaud',
          info: 'Ambassador, Permanent Representative of France to the OECD',
          image: '/images/boards/paris/Penicaud-Muriel.jpg'
        },
        {
          name: 'Patrick Pouyanné',
          info: 'Chairman and Chief Executive Officer, TotalEnergies',
          image: '/images/boards/paris/Pouyanne-Patrick.jpg'
        },
        {
          name: 'Ian Gallienne',
          info: 'Chief Executive Officer, GBL',
          image: '/images/boards/paris/Gallienne-Ian.jpg'
        },
        {
          name: 'Alain Fuchs',
          info: 'President, PSL University',
          image: '/images/boards/paris/Fuchs-Alain.jpg'
        },
        {
          name: 'Mathias Cormann',
          info: 'Secretary-General, Organisation for Economic Co-operation and Development (OECD)',
          image: '/images/boards/paris/Cormann-Mathias.jpg'
        },
        {
          name: 'James P. Gorman',
          info: 'Chairman and Chief Executive Officer, Morgan Stanley',
          image: '/images/boards/paris/James-Gorman.jpg'
        },
        {
          name: 'Amélie de Montchalin',
          info: 'Permanent Representative of France to the OECD',
          image: '/images/boards/paris/amelie.jpg'
        }
      ]
    },
    secretaries: {
      title: 'Secretaries',
      index: [
        {
          name: 'Bernard Spitz',
          info: 'President of European & International Affairs, MEDEF',
          image: '/images/boards/paris/Spitz-Bernard.jpg'
        }
      ]
    }
  },

  advisoryIndex: {
    title: 'Advisory Board',
    chairmen: {
      title: 'Chairwoman',
      index: [
        {
          name: 'Gwenaelle Avice-Huet',
          info: 'Chief Strategy & Sustainability Officer, Schneider Electric',
          image: '/images/boards/paris/Avice-Huet-Gwenaelle-cropped.jpg'
        }
      ]
    },
    members: {
      title: 'Members',
      index: [
        {
          name: 'Nicolas Blain',
          info: 'Head of the International relations and European affairs Unit, RATP Group',
          image: '/images/boards/paris/blain-nicolas.png'
        },
        {
          name: 'Didier Le Bret',
          info: 'Diplomat and Associate, ESL',
          image: '/images/boards/paris/Le-Bret-Didier.png'
        },
        {
          name: 'Eric Meyer',
          info: 'Head of France, RBC Capital Markets',
          image: '/images/boards/paris/meyer-eric.png'
        },
        {
          name: 'Dorothée Pineau',
          info: 'Advisor to the President, Mouvement des entreprises de France (MEDEF)',
          image: '/images/team/DorothéePineau.jpg'
        },
        {
          name: 'Bertrand Richard',
          info: 'Senior Advisor, Spencer Stuart',
          image: '/images/boards/paris/richard.jpg'
        }
      ]
    }
  }
}
